// extracted by mini-css-extract-plugin
export var details = "details-module--details--XPiNU";
export var summary = "details-module--summary--GwvU2";
export var content = "details-module--content--0vq2f";